import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const classicSoftwareBacklogEmbedRoute: InvariantJiraRoute = {
	name: 'rapidboard-backlog-embed',
	path: '/jira/software/c/projects/:projectKey/boards/:boardId/backlog/embed',
};
